import { connect } from 'react-redux';
import { ModalProvisionProcessing } from 'components/organisms';
import { isProvisionProcessingModalOpenSelector } from 'modules/layouts/selectors';

const mapStateToProps = (state: State.Root) => ({
  isProvisionProcessingModalOpen: isProvisionProcessingModalOpenSelector(state),
});

export const ModalProvisionProcessingContainer = connect(mapStateToProps)(ModalProvisionProcessing);
